var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticStyle: { "text-align": "center" } },
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-btn",
            {
              staticClass: "teal--text",
              attrs: { outline: "", icon: "", disabled: _vm.loaded === false },
              nativeOn: {
                click: function($event) {
                  _vm.playing ? _vm.pause() : _vm.play()
                }
              }
            },
            [
              _vm.playing === false || _vm.paused === true
                ? _c("v-icon", [_vm._v("play_arrow")])
                : _c("v-icon", [_vm._v("pause")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "teal--text",
              attrs: { outline: "", icon: "", disabled: _vm.loaded === false },
              nativeOn: {
                click: function($event) {
                  return _vm.stop()
                }
              }
            },
            [_c("v-icon", [_vm._v("stop")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "teal--text",
              attrs: { outline: "", icon: "", disabled: _vm.loaded === false },
              nativeOn: {
                click: function($event) {
                  return _vm.mute()
                }
              }
            },
            [
              _vm.isMuted === false
                ? _c("v-icon", [_vm._v("volume_up")])
                : _c("v-icon", [_vm._v("volume_off")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "teal--text",
              attrs: { outline: "", icon: "" },
              nativeOn: {
                click: function($event) {
                  _vm.loaded ? _vm.download() : _vm.reload()
                }
              }
            },
            [
              _vm.loaded === false
                ? _c("v-icon", [_vm._v("refresh")])
                : _c("v-icon", [_vm._v("get_app")])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-slider", {
            attrs: { dark: "" },
            nativeOn: {
              click: function($event) {
                return _vm.setPosition()
              }
            },
            model: {
              value: _vm.percentage,
              callback: function($$v) {
                _vm.percentage = $$v
              },
              expression: "percentage"
            }
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.currentTime) + " / " + _vm._s(_vm.duration))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("audio", {
        ref: "player",
        attrs: { id: "player", src: _vm.file },
        on: { ended: _vm.ended, canplay: _vm.canPlay }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-762053d2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-762053d2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vuetify-audio/src/vuetifyaudio.vue
// module id = null
// module chunks = 